var _rect, _rect2, _rect3, _rect4, _polygon, _polygon2, _rect5, _polygon3, _polygon4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLashawty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 841.89 595.276",
    enableBackground: "new 0 0 841.89 595.276",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "t",
    x: 401.327,
    y: 365.258,
    fill: "#070002",
    width: 3.096,
    height: 87.423
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "t",
    x: 384.791,
    y: 357.869,
    fill: "#070002",
    width: 36.168,
    height: 3.097
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 381.695,
    y: 136.836,
    fill: "#070002",
    width: 3.096,
    height: 87.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 381.695,
    y: 228.552,
    fill: "#070002",
    width: 34.62,
    height: 3.096
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    fill: "#070002",
    points: "428.888,111.846 391.648,206.658 394.975,206.658 430.999,114.942 433.827,114.942 450.814,158.195  418.637,158.195 417.421,161.291 452.031,161.291 469.85,206.658 473.176,206.658 435.937,111.846 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    fill: "#070002",
    points: "372.115,254.039 334.875,348.851 338.202,348.851 374.226,257.135 377.054,257.135 394.042,300.387  361.864,300.387 360.647,303.484 395.258,303.484 413.077,348.851 416.402,348.851 379.164,254.039 "
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 459.265,
    y: 217.288,
    fill: "#070002",
    width: 3.097,
    height: 94.812
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    fill: "#070002",
    points: "492.336,263.145 466.677,263.145 466.677,266.241 492.336,266.241 492.336,312.099 495.433,312.099  495.433,217.287 492.336,217.287 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "w",
    fill: "#070002",
    points: "479.681,379.167 476.853,379.167 462.444,342.483 484.06,287.451 480.733,287.451 460.781,338.249  440.828,287.451 437.503,287.451 459.117,342.483 444.71,379.167 441.882,379.167 405.858,287.451 402.531,287.451 439.771,382.262  446.82,382.262 460.781,346.718 474.741,382.262 481.791,382.262 519.03,287.451 515.704,287.451 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "line"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 841.89,
    height: 595.276
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s",
    fill: "#070002",
    d: "M431.274,223.145l-13.895-4.077c-6.386-1.873-10.657-7.618-10.386-13.971 c0.014-0.327,0.038-0.655,0.075-0.988c0.726-6.624,6.07-11.898,12.709-12.541c6.178-0.602,11.981,2.798,14.458,8.449 c0.79,1.801,1.19,3.721,1.19,5.704h3.097c0-2.414-0.488-4.751-1.45-6.947c-3.016-6.881-10.086-11.005-17.593-10.288 c-8.091,0.784-14.605,7.213-15.489,15.285c-0.044,0.399-0.074,0.798-0.091,1.193c-0.332,7.779,4.853,14.801,12.608,17.076 l13.895,4.076c8.691,2.55,15.561,8.927,18.375,17.061c1.284,3.709,1.756,7.608,1.404,11.59 c-1.207,13.628-12.442,24.426-26.133,25.119c-14.505,0.722-27.19-9.938-28.925-24.291c-0.134-1.108-0.202-2.238-0.202-3.359 c0-4.496,1.044-8.784,3.102-12.746l-2.747-1.428c-2.258,4.346-3.451,9.247-3.451,14.174c0,1.244,0.075,2.499,0.224,3.731 c1.866,15.442,15.149,27.051,30.593,27.051c0.518,0,1.04-0.013,1.562-0.04c15.226-0.77,27.72-12.781,29.062-27.938 c0.391-4.42-0.134-8.752-1.562-12.876C448.562,233.085,440.925,225.976,431.274,223.145"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "y",
    clipPath: "url(#SVGID_2_)",
    fill: "#070002",
    points: "415.603,390.695 444.958,429.765 444.958,485.507 448.055,485.507  448.055,428.805 419.485,390.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "y",
    clipPath: "url(#SVGID_2_)",
    fill: "#070002",
    points: "473.556,390.69 449.212,423.167 451.123,425.717 477.438,390.695  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "border",
    clipPath: "url(#SVGID_2_)",
    fill: "#070002",
    d: "M426.953,524.062c-33.34,0-61.888-24.699-66.722-57.574 c-24.61-14.311-39.865-40.657-39.865-68.939V198.917c0-28.924,15.763-55.573,41.181-69.711 c7.549-30.032,34.346-50.946,65.405-50.946c31.059,0,57.854,20.914,65.406,50.946c25.416,14.139,41.181,40.787,41.181,69.711 v198.631c0,28.282-15.258,54.629-39.865,68.939C488.841,499.363,460.291,524.062,426.953,524.062 M426.953,81.356 c-29.852,0-55.577,20.249-62.56,49.242l-0.16,0.668l-0.604,0.329c-24.776,13.507-40.167,39.303-40.167,67.322v198.631 c0,27.426,14.93,52.956,38.961,66.631l0.666,0.377l0.103,0.76c4.296,31.724,31.707,55.647,63.76,55.647 c32.053,0,59.463-23.924,63.761-55.647l0.102-0.76l0.666-0.377c24.031-13.675,38.959-39.205,38.959-66.631V198.917 c0-28.019-15.389-53.815-40.164-67.322l-0.603-0.329l-0.162-0.668C482.529,101.605,456.804,81.356,426.953,81.356"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLashawty);
export default __webpack_public_path__ + "static/media/lashawty.884b2d25a1d62e4eeead710c9a041075.svg";
export { ForwardRef as ReactComponent };